import React, { Fragment } from 'react';
import '../less/main.less';
import { ReactSVG } from 'react-svg';
import btn_icon from '../img/btn_icon.svg';
import DOMPurify from 'utils/sanitize';
import { backendTableToTariffsItems } from '../utils/backendTableToTariffsItems';
import { Preloader } from 'MWComponents';
import { getSafeLinkProps } from '../../../../helpers/utils/urlSecurity';

export default function template() {
  const { items, widget, title, btnLink, btnText, page, text, alignItems, onBtnClick, insuranceInfo, btnId, titleTag = "h2", btnWithImage } = this.props;

  const TitleTag = titleTag 

  const SANITIZE_CONFIG = {
    ADD_ATTR: ['target', 'rel']
  };

  const tableItems = widget ? backendTableToTariffsItems(widget) : items;

  if (widget && (!Array.isArray(tableItems) || tableItems.length === 0)) {
      return <Preloader/>
  }

  const hasButtonValue = tableItems.some(item =>
    Array.isArray(item.values) &&
    item.values.some(v => typeof v === 'object' && v.type === 'button')
  );

  const hasValues = tableItems.length > 0 && Array.isArray(tableItems[0].values) && !hasButtonValue;

  const renderLabel = (label) => {
    if (typeof label === "string") {
      return (
        <div dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(this.l10n(label), SANITIZE_CONFIG),
        }}/>
      );
    }

    return (
      <>
        <div dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(this.l10n(label.html), SANITIZE_CONFIG),
        }}/>
        {label.link && (
          <a
            href="#"
            className="tariffs__link"
            onClick={label.link.onClick}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(label.link.text))}}
          />
        )}
      </>
    );
  };

  const renderValue = (value, index) => {
    if (typeof value === 'object' && value !== null) {
      if (value.type === 'button') {
        return (
          <a
            key={index}
            {...getSafeLinkProps(value.btnLink, {navigate: this.navigate})}
            className="tariffs__special-link"
            id={value.btnId}
          >
            {this.l10n(value.btnText)}
          </a>
        );
      }
    }

    return (
      <div
        key={index}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(this.l10n(value), SANITIZE_CONFIG),
        }}
      />
    );
  };

  const renderRow = (item, colIndex) => {
    let valuesToRender;

    if (colIndex !== undefined) {
      valuesToRender = [item.values?.[colIndex]];
    } else if (Array.isArray(item.values)) {
      valuesToRender = item.values;
    } else {
      valuesToRender = [item.value];
    }

    return (
      <div className={`tariffs__row tariffs__row_align-${alignItems ? alignItems : 'center'}`}>
        <div className="tariffs__label">{renderLabel(item.label)}</div>
        {valuesToRender.map((value, i) => (
          <div
            key={i}
            className={`tariffs__cell${insuranceInfo ? ' tariffs__cell_insurance-info' : ''}`}
          >
            {renderValue(value, i)}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={`tariffs${hasButtonValue ? ' tariffs_with-btns' : ''}`}>
      <div className="container">
        {title && <TitleTag className="tariffs__title">{this.l10n(title)}</TitleTag>}
        {!hasValues && (
          <div className="tariffs__table">
            {tableItems.map((item, i) => (
              <Fragment key={i}>{renderRow(item)}</Fragment>
            ))}
          </div>
        )}
        {hasValues && (
          <>
            {!this.state.isMobile && (
              <div className="tariffs__table">
                {tableItems.map((item, i) => (
                  <div className={`tariffs__row tariffs__row_align-${alignItems ? alignItems : 'center'}`} key={i}>
                    <div className="tariffs__label">
                      {renderLabel(item.label)}
                    </div>
                    {item.values.map((value, j) => (
                      <div
                        className={`tariffs__cell${insuranceInfo ? ' tariffs__cell_insurance-info' : ''}`}
                        key={j}
                      >
                        {renderValue(value, j)}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
            {this.state.isMobile && (
              hasButtonValue ? (
                <div className="tariffs__table">
                  {tableItems.map((item, i) => (
                    <Fragment key={i}>{renderRow(item)}</Fragment>
                  ))}
                </div>
              ) : (
                tableItems.length > 0 && tableItems[0].values.map((_, col) => (
                  <div className="tariffs__table mobile" key={col}>
                    {tableItems.map((item, row) => (
                      <Fragment key={row}>
                        {renderRow(item, col)}
                      </Fragment>
                    ))}
                  </div>
                ))
              )
            )}
          </>
        )}
        {text && <div className="tariffs__text">{this.l10n(text)}</div>}
        {(btnLink && btnText) && (
          <a className="tariffs__btn btn-tariffs" {...getSafeLinkProps(btnLink, {navigate: this.navigate})} id={`${page ? page : ''} tariffs-button`}>
            <ReactSVG src={btn_icon} className="btn-tariffs__image"/>
            <span className="btn-tariffs__text">{this.l10n(btnText)}</span>
          </a>
        )}
        {(onBtnClick && btnText) && (
          <button className="tariffs__btn btn-tariffs" onClick={onBtnClick} id={`${page ? page : ''} tariffs-button${btnId ? ` ${btnId}` : ''}`}>
            {btnWithImage && <ReactSVG src={btn_icon} className="btn-tariffs__image"/>}
            <span className="btn-tariffs__text">{this.l10n(btnText)}</span>
          </button>
        )}
      </div>
    </div>
  );
}
